'use strict'

Vue.component('awe-avails-tab-view', {
  props: {
    defaultTab: {
      type: String,
      default: 'online',
      validator(value) {
        return ['online', 'offline'].includes(value);
      },
    },
    showOfflineBuyBtn: {type: Boolean, default: true},
    onlineTabLabel: {type: String, default: ''},
    offlineTabLabel: {type: String, default: ''},
    offlineAvails: {type: Array, default: () => {return []}},
    onlineAvails: {type: Array, default: () => {return []}},
    onlineOnly: {type: Boolean, default: false},
    displayPrices: {type: Boolean, default: true},
    ready: {type: Boolean, default: false},
  },
  data: function(){
    return {
      i18n: window.i18n,
      selectedTab: this.defaultTab,
      error: '',
      app: app,
    }
  },
  watch: {
    defaultTab: {
      handler: function(newVal) {
        this.selectedTab = newVal;
        if (newVal === 'offline')
          app.showMap(null, false, true)
      },
      immediate: true,
    }
  },
  methods: {
    showNoStoresMessage: function(storeAvailability) {
      return storeAvailability.length === 0 && this.ready && this.error != 'UNAVAILABLE_COUNTRY_ERROR'
    },
    showStoreHours: function(item) {
      return (item.nearestStore || item.store).openingHours || (item.nearestStore || item.store).open24;
    },
    getImgUrl: function(item) {
      return `https://content.static-swaven.com/img/retailers/hd/${item.retailer.logoId}.png`;
    },
    offlineTabClickHandler: function() {
      this.selectedTab = 'offline';
      app.showMap(null, false, true)
    },
    onlineTabClickHandler: function() {
      this.selectedTab = 'online'
    },
    shouldShowItemPrice: function(item) {
      if (this.selectedTab === 'online') {
        return this.displayPrices && item.price.canShow;
      } else {
        return this.displayPrices && item.price.canShow && this.showOfflineBuyBtn && item.clkUrl;
      }
    },
    getAriaLabel: function(tag, item, getStoreFullName) {
      let name = item?.store.name;
      if (getStoreFullName) {
        name = Utils.getStoreFullname(item);
      }
      return i18n.getString(tag, 'name', name);
    }
  },

  template: `
    <div class="stores avails-tab-view" :class="this.selectedTab" ref="availsTabView">
      <div id="tabs" v-if="!onlineOnly" role="tablist" :aria-activedescendant="this.selectedTab + '-tab'">
        <button id="online-tab" class="tab" role="tab"
            v-on:click="onlineTabClickHandler" tabindex="0"
            :aria-label="onlineTabLabel || i18n.getString('FIND_ONLINE')"
            :aria-selected="(this.selectedTab==='online').toString()"
            aria-controls="online-stores">
          <label>{{onlineTabLabel || i18n.getString('FIND_ONLINE')}}</label>
        </button>
        <button id="offline-tab" class="tab" role="tab"
            v-on:click="offlineTabClickHandler" tabindex="0"
            :aria-label="offlineTabLabel || i18n.getString('FIND_STORE')"
            :aria-selected="(this.selectedTab==='offline').toString()"
            aria-controls="offline-stores">
          <label>{{offlineTabLabel || i18n.getString('FIND_STORE')}}</label>
        </button>
      </div>
      <div class="store-ctnr">
        <!-- Map -->
        <slot name="map">
          <div class="missing-map">NO MAP HERE</div>
        </slot>
        <!-- Online stores -->
        <div id="online-stores" class="online" v-show="this.selectedTab === 'online'"
        dyn-class="{ onlineonly: onlineOnly }"
        role="tabpanel">
          <div v-if="showNoStoresMessage(onlineAvails)" class="error" role="dialog">{{i18n.getString('NOSTORE_ONLINE')}}</div>
          <div v-else-if="error" class="error" role="dialog">
            <span>{{i18n.getString(error)}}</span>
          </div>
          <div v-else v-for="item in onlineAvails" role="listitem" class="row">
            <div class="img-ctnr">
              <img class="retailer-logo" :src="getImgUrl(item)" :alt="item?.retailer?.name">
            </div>
            <div class="price" v-if="shouldShowItemPrice(item)">
              {{i18n.formatPrice(item?.price?.amount, item?.price?.currency)}}
            </div>
            <a
              v-on:click="app.redirect($event, item)"
              :href="item.clkUrl"
              :aria-disabled="!item.clkUrl"
              :aria-label="getAriaLabel('BUY_LBL', item)"
              class="btn"
              target="_blank"
            >
              <span>{{i18n.getString('BUY')}}</span>
              <svg enable-background="new 0 0 24 24" width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="m18 23h-14c-1.654 0-3-1.346-3-3v-14c0-1.654 1.346-3 3-3h8c.552 0 1 .447 1 1s-.448 1-1 1h-8c-.551 0-1 .448-1 1v14c0 .552.449 1 1 1h14c.551 0 1-.448 1-1v-8c0-.553.448-1 1-1s1 .447 1 1v8c0 1.654-1.346 3-3 3z"/></g><path d="m22 1h-6c-.404 0-.769.243-.924.617s-.069.804.217 1.09l2.293 2.293-7.293 7.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l7.293-7.293 2.293 2.293c.191.191.447.293.707.293.129 0 .259-.024.383-.076.373-.154.617-.52.617-.924v-6c0-.553-.448-1-1-1z"/></svg>
            </a>
          </div>
          <awe-loader ref="loader_avails_next_1" type="avails-next" class="inline"></awe-loader>
        </div>
        <!-- Offline stores -->
        <div id="offline-stores" v-if="!onlineOnly" class="offline"
        v-show="this.selectedTab === 'offline'"
        role="tabpanel">
          <div v-if="showNoStoresMessage(offlineAvails)" class="error" role="dialog">{{i18n.getString('NOSTORE_OFFLINE')}}</div>
          <div v-else-if="error" class="error" role="dialog">
            <span>{{i18n.getString(error)}}</span>
          </div>
          <div v-else v-for="item in offlineAvails"
          :data-store-id="item.store.id"
          @click="app.showMap(item)" class="row" role="listitem">
            <!-- logo -->
            <div class="logo">
              <div class="img-ctnr">
               <img :src="getImgUrl(item)" :alt="item.retailer.name">
              </div>
            <div class="price" v-if="shouldShowItemPrice(item)">{{i18n.formatPrice(item.price.amount, item.price.currency)}}</div>
          </div>
          <!-- address -->
          <div class="address">
            <!-- <span class="icon-map"></span> -->
            <div class="dist">{{i18n.formatDistance(item.store.distance, true)}}</div>
            <span v-if="!item.retailer.name || item.retailer.isDefaultLogo" class="name">{{item.store.name}}</span>
            <span v-if="item.store.location.address">{{item.store.location.address}}</span>
            <span v-if="item.store.location.city">{{item.store.location.city}}</span>
            <span v-if="item.store.location.zipCode">{{item.store.location.zipCode}}</span>
          </div>
          <!-- phone -->
          <div v-if="item.store.phone" class="phone">
            <!-- <span class="icon-phone"></span> -->
            <a :href="'tel:+'+ item.store.phone"
              :aria-label="getAriaLabel('PHONE_LBL', item, true)"
              >
              {{item.store.phone}}
            </a>
          </div>
          <!-- buttons -->
          <div class="buttons">
            <div
              class="btn route"
              v-on:click="app.showMap(item, true, false)"
              tabindex="0"
              role="button"
              :aria-label="getAriaLabel('SHOWROUTE_LBL', item, true)"
            ><span>{{i18n.getString('SHOWROUTE')}}</span></div>
            <a
              v-if="showOfflineBuyBtn && item.clkUrl"
              v-on:click="app.redirect($event, item)"
              :href="item.clkUrl"
              :aria-disabled="!item.clkUrl"
              :aria-label="getAriaLabel('BUY_LBL', item)"
              target="_blank"
              class="buy-btn"
              dyn-class="{ disabled: !item.clkUrl }"
            >
             <span>{{i18n.getString('BUY')}}</span>
              <svg enable-background="new 0 0 24 24" width="14px" height="14px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="m18 23h-14c-1.654 0-3-1.346-3-3v-14c0-1.654 1.346-3 3-3h8c.552 0 1 .447 1 1s-.448 1-1 1h-8c-.551 0-1 .448-1 1v14c0 .552.449 1 1 1h14c.551 0 1-.448 1-1v-8c0-.553.448-1 1-1s1 .447 1 1v8c0 1.654-1.346 3-3 3z"/></g><path d="m22 1h-6c-.404 0-.769.243-.924.617s-.069.804.217 1.09l2.293 2.293-7.293 7.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l7.293-7.293 2.293 2.293c.191.191.447.293.707.293.129 0 .259-.024.383-.076.373-.154.617-.52.617-.924v-6c0-.553-.448-1-1-1z"/></svg>
            </a>
          </div>
          <!-- opening hours -->
          <awe-opening-hours v-if="showStoreHours(item)"
            :hours="(item.nearestStore || item.store).openingHours"
            :timezone="(item.nearestStore || item.store).timezone"
            :open24="(item.nearestStore || item.store).open24"
          >
          </awe-opening-hours>
        </div>
        <awe-loader ref="loader_avails_next_1" type="avails-next" class="inline"></awe-loader>
      </div>
      </div>
    </div>
  `
})

